import React from 'react';
import {
  Box,
  Typography,
  TableCell,
  Button,
  Tooltip,
  Zoom,
} from '@mui/material';
import MUIDataTable from 'mui-datatables';
import capitalize from 'app/utils/capitalize';
import DownloadIcon from '@mui/icons-material/Download';
import { ApiService } from 'app/servicesTwo/ApiService';
import { capitalizeFLetter } from '@jumbo/utils';
import moment from 'moment';
import 'moment/locale/pt-br';
import useSwalWrapper from '@jumbo/vendors/sweetalert2/hooks';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { GreatVibesRegular } from 'assets/fonts/GreatVibes-regular';
import { useLocation } from 'react-router-dom';

const SpiritualAssistanceTrainingsList = ({
  trainings = [],
  user,
  director,
}) => {
  const { pathname } = useLocation();

  moment.locale('pt-br');
  pdfMake.vfs = pdfFonts.pdfMake.vfs;
  window.pdfMake.vfs['GreatVibes-Regular.ttf'] = GreatVibesRegular;
  pdfMake.fonts = {
    Roboto: {
      normal: 'Roboto-Regular.ttf',
      bold: 'Roboto-Medium.ttf',
      italics: 'Roboto-Italic.ttf',
      bolditalics: 'Roboto-MediumItalic.ttf',
    },
    GreatVibes: {
      normal: 'GreatVibes-Regular.ttf',
      bold: 'GreatVibes-Regular.ttf',
      italics: 'GreatVibes-Regular.ttf',
      bolditalics: 'GreatVibes-Regular.ttf',
    },
  };

  const Swal = useSwalWrapper();
  const toast = (variant, message) => {
    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
    });
    Toast.fire({ icon: variant, title: message, showCloseButton: true });
  };

  const loadImageBase64 = (path) => {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.onload = function () {
        const reader = new FileReader();
        reader.onloadend = function () {
          resolve(reader.result);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.open('GET', path);
      xhr.responseType = 'blob';
      xhr.send();
    });
  };

  const gerarCertificado = async (pessoa, diretor, nomeDoCurso, curso) => {
    if (!diretor) {
      return toast(
        'error',
        'Diretoria não cadastrada para este curso. Entrar em contado com a Secretaria de Ensino: 011 3188-8383 r. 237'
      );
    }
    const areaImageUrl = director?.Area?.imagem_area
    ? `${process.env.REACT_APP_API_KEY}/images/${director.Area.imagem_area}`
    : null;

    const [bg, logo, assinatura, iconArea] = await Promise.all([
      loadImageBase64('/images/certificado_moldura.png'),
      loadImageBase64('/images/logositefeesp.png'),
      loadImageBase64(
        `${process.env.REACT_APP_API_KEY}/images/${diretor?.assinatura}`
      ),
      //loadImageBase64('/images/ICONE_AREA_ENSINO.png'),
      areaImageUrl
      ? loadImageBase64(areaImageUrl).catch(() => null)
      : Promise.resolve(null),
    ]);

    const formattedDate = moment(curso?.createdAt).format(
      'DD [de] MMMM [de] YYYY'
    );
    const cargaHoraria = curso?.Turma?.Curso?.carga_horaria;
    const anoTurma = curso?.Turma?.ano;

    const areaObj = diretor?.Area;
    const areaName = areaObj?.nome || '';
    const areaPhone = areaObj?.telefone || '';
    const areaRamal = areaObj?.ramal || '';

    const texto = cargaHoraria
      ? `Com carga horária de: ${cargaHoraria}, em ${anoTurma}.`
      : '-';

    const docDefinition = {
      pageSize: 'A4',
      pageMargins: [60, 50, 60, 50],
      background: [{ image: bg, width: 590 }],
      content: [
        {
          columns: [
            { 
              image: logo, width: 200, margin: [0, 0, 0, 10] 
            },
            ...(iconArea
              ? [
                  {
                    image: iconArea,
                    width: 135,
                    margin: [135, 30, 0, 0],
                  },
                ]
              : []),
          ],
        },
        {
          stack: [
            { text: 'CERTIFICADO', style: 'header', alignment: 'center' },
            {
              text: [
                'Conferido a ',
                {
                  text: pessoa.nome,
                  style: 'content',
                  bold: true,
                  font: 'GreatVibes',
                  fontSize: 28,
                },
                ` CPF ${pessoa.cpf ?? '-'}, pela conclusão do curso: `,
                { text: nomeDoCurso, bold: true },
                ` ${texto}`,
              ],
              style: 'content',
              alignment: 'center',
              margin: [0, 5, 0, 5],
            },
            {
              alignment: 'center',
              stack: [
                {
                  image: assinatura,
                  width: 150,
                  height: 60,
                  absolutePosition: { x: 50, y: 280 },
                },
                {
                  text: '______________________________',
                  absolutePosition: { x: 50, y: 315 },
                },
                {
                  text: `${diretor?.User?.nome}`,
                  bold: true,
                  absolutePosition: { x: 50, y: 330 },
                },
                {
                  text: `Direção da Área de ${capitalizeFLetter(
                    diretor?.Area?.nome ?? ''
                  )}`,
                  absolutePosition: { x: 50, y: 345 },
                },
              ],
            },
            {
              text: `São Paulo. Emitido em ${new Date().toLocaleDateString(
                'pt-BR'
              )}, às ${new Date().toLocaleTimeString('pt-BR')}, via sistema.${
                areaPhone
                  ? ` Dúvidas: entrar em contato com a área de ${capitalizeFLetter(
                      areaName.toLowerCase()
                    )} pelo telefone ${areaPhone}${
                      areaRamal ? ` ramal ${areaRamal}` : ''
                    }`
                  : ''
              }`,
              style: 'dataEmissao',
              alignment: 'center',
              absolutePosition: { x: 50, y: 365 },
            },
          ],
        },
      ],
      defaultStyle: { font: 'Roboto' },
      styles: {
        header: { fontSize: 24, bold: true, color: '#1473B9' },
        content: { fontSize: 18 },
        dataEmissao: { fontSize: 10, italics: true, margin: [0, 40, 0, 0] },
      },
    };

    pdfMake.createPdf(docDefinition).download('certificado.pdf');
  };

  const getDirectorForCertified = async (id, user, nomeDoCurso, curso) => {
    try {
      const response = await ApiService.get(`/diretores/curso-historico/${id}`);
      gerarCertificado(user, response.data?.director, nomeDoCurso, curso);
    } catch (error) {
      const errMsg =
        error?.response?.data?.error || 'Erro ao gerar certificado.';
      toast('error', errMsg);
    }
  };
  console.log({ trainings });
  const columns = [
    {
      name: 'Turma',
      label: 'Nome',
      options: {
        customBodyRender: (_, tableMeta) => {
          const curso = trainings[tableMeta.rowIndex];
          return (
            <Typography variant='body1'>
              {curso?.Turma?.Curso?.nome ?? curso?.curso_compativel_nome}
            </Typography>
          );
        },
      },
    },
    {
      name: 'Turma.ano',
      label: 'Conclusão',
      options: {
        customBodyRender: (value) => (
          <Typography variant='body1'>{value ?? '-'}</Typography>
        ),
      },
    },
    {
      name: 'Turma',
      label: 'Local',
      options: {
        customBodyRender: (value) => {
          const nomeCentro = value?.Centro_Espirita?.nome_fantasia;
          const localTraduzido =
            value?.local === 'Sede'
              ? 'Sede Maria Paula'
              : value?.local === 'sede_santo_amaro'
              ? 'Sede Santo Amaro'
              : value?.local;

          return (
            <Typography variant='body1'>
              {nomeCentro || capitalize(localTraduzido)}
            </Typography>
          );
        },
      },
    },
    {
      name: 'Turma.Curso.nome',
      label: 'Gerar Certificado',
      options: {
        //display: pathname?.startsWith('/app/meus-dados') ? true : false,
        customHeadRender: (
          columnMeta,
          handleToggleColumn,
          sortOrder,
          sortColumn
        ) => (
          <TableCell align='center'>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              Gerar Certificado
              <Box
                component='span'
                sx={{
                  fontSize: '0.7rem',
                  color: 'error.main',
                  fontWeight: 'bold',
                  lineHeight: 1,
                }}
              >
                (Somente após 2024)
              </Box>
            </Box>
          </TableCell>
        ),
        customBodyRender: (value, tableMeta) => {
          const curso = trainings[tableMeta.rowIndex];
          return (
            <Box display={'flex'} justifyContent={'center'} alignItems={'center'}>
              <Button
                variant='contained'
                size='small'
                color='info'
                onClick={() =>
                  getDirectorForCertified(
                    curso?.curso_historico_id,
                    user,
                    value,
                    curso
                  )
                }
                //disabled={!director?.assinatura}
              >
                <Tooltip
                  title='Gerar Certificado'
                  TransitionComponent={Zoom}
                  arrow
                >
                  <DownloadIcon />
                </Tooltip>
              </Button>
            </Box>
          );
        },
      },
    },
  ];

  const options = {
    pagination: false,
    selectableRows: 'none',
    search: false,
    download: false,
    print: false,
    filter: false,
    viewColumns: false,
    enableNestedDataAccess: '.',
    textLabels: {
      pagination: {
        next: 'Próxima Página',
        previous: 'Página Anterior',
        rowsPerPage: 'Itens por Página:',
        displayRows: 'de',
      },
    },
    setTableProps: () => ({ size: 'small' }),
  };

  return (
    <Box mt={4} mb={2}>
      <Typography variant='h4' textAlign='center'>
        Treinamentos realizados na Assistência Espiritual
      </Typography>
      {trainings.length > 0 ? (
        <MUIDataTable data={trainings} columns={columns} options={options} />
      ) : (
        <Typography textAlign='center'>Nenhum curso encontrado.</Typography>
      )}
    </Box>
  );
};

export default SpiritualAssistanceTrainingsList;
